// <img> with an optional phone-specific crop.
//
// Many photos fill an object-fit: cover box that is portrait on phones and wide
// on desktop, so phones get their own pre-cropped file (see
// scripts/optimize-static-images.sh). Up to 480px wide the browser downloads
// only `mobileSrc`; above that, only `src`.
//
// <picture> uses display: contents, so the <img> is laid out exactly as if it
// were a direct child: existing width/height/position classes and CSS
// selectors like `.hero img` keep working unchanged.
const ResponsiveImg = ({ src, mobileSrc, alt = "", ...imgProps }) => {
  if (!mobileSrc) return <img src={src} alt={alt} {...imgProps} />;
  return (
    <picture style={{ display: "contents" }}>
      <source media="(max-width: 480px)" srcSet={mobileSrc} type="image/webp" />
      <img src={src} alt={alt} {...imgProps} />
    </picture>
  );
};

export default ResponsiveImg;
